import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";

export function RecordsHeld({ records, testid = "records-held" }) {
  if (!records || records.length === 0) return null;
  return (
    <div data-testid={testid} className="rounded-2xl foil-border bg-gradient-to-b from-[#1a1407] to-[#070707] p-5">
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-[#E5B842] font-mono font-bold mb-4">
        <Trophy className="w-4 h-4" /> Records Held · {records.length}
      </div>
      <div className="space-y-2">
        {records.map((r) => (
          <Link
            key={r.category}
            to="/hall-of-fame"
            data-testid={`record-held-${r.category}`}
            className="flex items-center justify-between gap-3 rounded-lg bg-[#000000] border border-[#2b2512] px-3 py-2 hover:border-[#E5B842]/50"
            style={{ transition: "border-color 0.15s ease" }}
          >
            <div className="min-w-0">
              <div className="text-sm font-semibold text-slate-100 truncate">{r.label}</div>
              {r.context?.text && <div className="text-[10px] font-mono text-slate-500 truncate">{r.context.text}</div>}
            </div>
            <span className="shrink-0 font-heading text-lg font-black text-[#E5B842] tabular-nums">{r.value_str}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
